// The same rule as the server's (menciones.py): name without accents, lower case, words joined by "_".
export const aHandle = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
  .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '')

// Every handle that names this person: the full name, first_last and the full name with their id.
export function variantes(u) {
  const largo = aHandle(u.nombre)
  const p = largo.split('_').filter(Boolean)
  const out = [largo, `${largo}_${u.id}`]
  if (p.length >= 2) out.push(`${p[0]}_${p[p.length - 1]}`)
  return [...new Set(out)]
}
